import download from "js-file-download";
import _ from "lodash";
import { Loading, Message, MessageBox } from 'element-ui';
import instance from '../axios';

/**
 * 格式化时间 yyyy-M-d H:mm:s
 * @param {Boolean} isHMS 是否需要时分秒 默认true需要
 * @param {String} ymdDivision 年月日分割符 默认 -
 * @param {String} hmsDivision 时分秒分隔符 默认 :
 * @returns 时间格式
 */

Date.prototype.toDate = function (isHMS = true, ymdDivision = '-', hmsDivision = ':') {
    let y = this.getFullYear();
    let M = this.getMonth() + 1;
    let d = this.getDate();
    let hms = '';
    if (isHMS) {
        let h = this.getHours();
        let m = this.getMinutes();
        let s = this.getSeconds();
        hms = ` ${h + hmsDivision + (m > 10 ? m : "0" + m) + hmsDivision + s}`;
    }
    return `${y + ymdDivision + M + ymdDivision + d}${hms}`;
}

//  对Date的扩展，将 Date 转化为指定格式的String
//  月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
//  年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
//  例子：
//  (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
//  (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format =  function (fmt) {
  let o = {
     "M+":  this.getMonth() + 1,  // 月份
     "d+":  this.getDate(),  // 日
     "h+":  this.getHours(),  // 小时
     "m+":  this.getMinutes(),  // 分
     "s+":  this.getSeconds(),  // 秒
     "q+": Math.floor(( this.getMonth() + 3) / 3),  // 季度
     "S":  this.getMilliseconds()  // 毫秒
 };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, ( this.getFullYear() + "").substring(4 - RegExp.$1.length));
  for ( let k  in o)
  if ( new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substring(("" + o[k]).length)));
  return fmt;
}

// vuescroll配置
const scrollOps = {
    bar: {
        background: '#6c757d'
    }
}

/**
 * 三级联动
 * @param {Object} (array: Array, NoLabel: String, No: String)
 * @returns {Array} Array<String, any>
 */
function linkage({ array, NoLabel, No }) {
    let result = [];
    for (let i = 0; i < array.length; i++) {
        if (array[i][NoLabel] === No) {
            result.push(array[i]);
        }
    }
    return result;
}

function linkageMultiple({ array, NoLabel, Nos }) {
  let result = [];
  for( let i = 0 ; i <  Nos.length; i++) {
    const innerResult = linkage({
      array: array,
      NoLabel: NoLabel,
      No: Nos[i]
    });
    result.push(innerResult)
  }
  return _.flatten(result);
}

/**
 * 文件导出
 * @param {Object} res
 * @returns fileName
 */

const exportFile = async ({ method, url, data }) => {
  let loadingInstance = Loading.service()
  try {
    console.log('url', url)
    let response = await instance({
      method,
      responseType: "blob",
      url,
      data
    });

    console.log('response', response)

    let fileName = response.headers["content-disposition"].split("''")[1];
    if(!fileName) {
      fileName = response.headers["content-disposition"].split("=")[1];
    }
    fileName = decodeURI(fileName);

    let res = response.data;
    const blob = new Blob([res], { type: "application/vnd.ms-excel" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(a.href);
    a.remove();
    return { data: response, fileName };
  }
  catch (e) {
    let res = await instance({
      method,
      url,
      data
    });
    if (res.data.code !== 200 && res.data.code !== 403) {
      let errorMsg = res.data.message || res.data.msg
      Message.warning({
        message: errorMsg || '操作失败'
      })
    }
  }
  finally {
    loadingInstance.close();
  }
}

const getUrlParams = function(key) {
  let url = window.location.href
  // 通过 ? 分割获取后面的参数字符串
  if (url.split('?').length === 1) {
    return ''
  }
  let urlStr = url.split('?')[1]
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split('&')
  for(let i = 0,len = paramsArr.length;i < len;i++){
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split('=')
    obj[arr[0]] = arr[1];
  }
  return obj[key] || ''
}


/**
 * 操作二次确认
 * @param description {String} 提示内容
 * @returns
 */
const secondConfirm = async function (description){
  return await MessageBox.confirm(description, '提示', {
    confirmButtonText: '确认',
    cancleButtonText: '取消',
    type: 'warning'
  }).then(()=>true).catch(()=>{
    Message.info("操作取消！")
    return false
  });
}

export default {
    scrollOps,
    linkage,
    linkageMultiple,
    exportFile,
    getUrlParams,
    secondConfirm
}


/**
 * 下载文件
 * url: 下载的文件地址
 * name: 下载的文件的名字
 */
export const downloadFile = async function (url, name) {
  const result = await instance({
    method: "get",
    url,
    responseType: "blob",
  });
  download(result.data, name);
}



// WEBPACK FOOTER //
// ./src/utils/tool.js